export default __webpack_public_path__ + "static/media/fi.461f95d1.svg";